
declare var window: any;

export const GetUrlParameterByName = (name: string, url = window.location.href) => {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export const CheckSystem = {
    iOS: function () {
        var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        return iOS;
    },
    MAC: function () {
        var MAC = /macintosh|mac os x/i.test(navigator.userAgent) && !window.MSStream;
        return MAC;
    },
    Android: function () {
        var android = /Android/.test(navigator.userAgent) && !window.MSStream;
        return android;
    },
    isMobile: function () {
        return /Mobi|Android|iPhone/i.test(navigator.userAgent)
    }
}

export const CopyValueToSystem = (value: string) => {
    return new Promise<void>((resolve, reject) => {
        let input = document.createElement('input');
        document.body.appendChild(input);
        input.setAttribute('value', value);
        input.select();
        if (document.execCommand('copy')) {
            document.execCommand('copy');
            resolve()
        } else {
            reject()
        }
        document.body.removeChild(input);
    })
}